import $ from 'jquery';
import {isMobile} from '../utilities';

class rateCalculator {
  constructor(element) {
    this.$el = $(element);
    this.$inputs = this.$el.find("select");
    this.$selectNights = this.$el.find("select[name='nights']");
    this.$selectRoomType = this.$el.find("select[name='room_type']");
    this.$selectSeason = this.$el.find("select[name='season']");

    this.$nypInput = $("#nyp");

    this.rates = {
      "1": {
        "round_cove_suite": 1401.96,
        "signature_water_view": 683.43,
        "signature_water_side": 573.73,
        "signature_junior_suite": 683.43,
        "premier_water_views": 573.73,
        "water_view": 524.36,
        "premier_cottage_style": 496.94,
        "cottage_style": 442.09,
        "premier_garden_view": 387.24,
        "garden_view": 332.39,
        "tulip": 606.64
      },
      "2": {
        "round_cove_suite": 2219.24,
        "signature_water_view": 1182.57,
        "signature_water_side": 935.75,
        "signature_junior_suite": 1401.97,
        "premier_water_views": 793.14,
        "water_view": 743.77,
        "premier_cottage_style": 716.35,
        "cottage_style": 606.65,
        "premier_garden_view": 524.37,
        "garden_view": 496.95,
        "tulip": 821.66
      },
      "3": {
        "round_cove_suite": 2877.44,
        "signature_water_view": 1429.40,
        "signature_water_side": 1100.30,
        "signature_junior_suite": 1703.65,
        "premier_water_views": 990.60,
        "water_view": 902.84,
        "premier_cottage_style": 853.47,
        "cottage_style": 716.35,
        "premier_garden_view": 606.65,
        "garden_view": 573.74,
        "tulip": 1072.87
      },
      "4": {
        "round_cove_suite": 3376.57,
        "signature_water_view": 1840.77,
        "signature_water_side": 1511.67,
        "signature_junior_suite": 2087.60,
        "premier_water_views": 1341.64,
        "water_view": 1100.30,
        "premier_cottage_style": 1072.87,
        "cottage_style": 963.17,
        "premier_garden_view": 798.62,
        "garden_view": 771.20,
        "tulip": 1341.64
      }
    }
    this.listen();
  }

  listen(){
    let that = this;
    this.$inputs.on('change', function(e){
      that.calculate();
    })

  }
  calculate(){

    let numNight = Number(this.$selectNights.val());
    let roomType = this.$selectRoomType.val();
    let season = this.$selectSeason.val();

    let totalPrice = this.rates[season][roomType] * numNight;

    this.$nypInput.val(totalPrice.toFixed(2));



  }
}

$('.weq-rate-calculator').each((index, element) => {
  new rateCalculator(element);
})
